import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

import { literals } from "@/constants/literals";

export interface ConfirmTotalImagesContentProps {
  closeQuestion: () => void;
  continueEdition: (status: "APROBED") => void;
  totalImagesAffected: number;
}

const ConfirmTotalImagesContent = ({
  closeQuestion,
  totalImagesAffected,
  continueEdition,
}: ConfirmTotalImagesContentProps) => {
  return (
    <div className="w-full grid gap-4">
      <div>
        <p
          data-testid="modal-text"
          className="text-sm text-ib-pt-color-gray-1000"
        >
          {totalImagesAffected === 1 ? (
            literals.onePictureChanges
          ) : (
            <>
              <span>{literals.severalPictureChanges1}</span>
              <span className="font-ib-bold">{totalImagesAffected}</span>
              <span className="font-ib-bold">
                {literals.severalPictureChanges2}
              </span>
              <span>{literals.severalPictureChanges3}</span>
            </>
          )}
        </p>
      </div>
      <PrimaryButton
        colour="red"
        icon="checkUnderline"
        label={literals.confirmAndExit}
        onClick={continueEdition}
      />
      <SecondaryButton
        colour="red"
        label={literals.cancel}
        onClick={closeQuestion}
      />
    </div>
  );
};

export default ConfirmTotalImagesContent;
